// @flow

import * as Actions from 'actionTypes';

/**
 /**
 * It runs the correct action received
 * @param {object} state of the application
 * @param {object} action received
 * @return {object} new object whic represent the new state after the action
 */
const initialState = {
  isModalOpen: false,
  postCode: {
    isValid: true
  }
};

const ui = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case Actions.CHECK_POSTCODE: {
      const newState = Object.assign({}, state);
      newState.isLoading = true;
      newState.error = false;
      newState.lastPostCode = action.postcode;
      return newState;
    }

    case Actions.ADD_POSTCODE: {
      const newState = Object.assign({}, state);
      newState.isLoading = false;
      newState.error = false;
      newState.lastPostCode = action.lastPostCode;
      return newState;
    }

    case Actions.ADD_POSTCODE_RESULT: {
      const newState = {
        ...state,
        isLoading: false,
        error: false,
        postCode: {
          ...action.result
        }
      };

      if (!action.result.isValid) {
        newState.lastPostCode = '';
      }

      return newState;
    }

    case Actions.OPEN_MODAL:
      return {
        ...state,
        isModalOpen: true
      };

    case Actions.CLOSE_MODAL:
      return {
        ...state,
        isModalOpen: false
      };

    case Actions.ADD_RESULTS_FAILED:
    case Actions.ADD_POSTCODE_RESULT_FAILED:
    case Actions.ADD_POSTCODE_FAILED:
    case Actions.ADD_LISTING_FAILED:
      return {
        ...state,
        error: true
      };

    case Actions.ADD_RESULTS:
    case Actions.ADD_INITIAL_RESULTS:
    case Actions.ADD_LISTING:
    case Actions.FETCH_RESULTS:
    case Actions.FETCH_INITIAL_RESULTS:
    case Actions.FETCH_MAKES:
    case Actions.FETCH_LISTING:
      return {
        ...state,
        error: false
      };

    default:
      return state;
  }
};

export default ui;



// WEBPACK FOOTER //
// ./src/reducers/ui.reducer/index.js